import { defineRule, configure } from 'vee-validate'
import { required, email, min, regex, alpha_spaces } from '@vee-validate/rules'
import { api } from '@/services'

defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('regex', regex)
defineRule('alpha_spaces', alpha_spaces)

defineRule('person_name', (value: string) => {
  if (!value) return true
  return /^[\p{L}\-' ]{1,255}$/u.test(value) || 'person_name'
})

defineRule('phone', (value: string) => {
  if (!value) return true
  return /^\+?\(?\d{1,4}\)?[-\s./\d]*$/.test(value) || 'Invalid phone number'
})

defineRule('user_exists', async (value: string) => {
  if (!value) return true
  return await api.checkUserExist(value)
})

defineRule('no_corporate_mail', (value: string) => {
  if (!value) return true
  const normalizedValue = value.toLowerCase()
  return !normalizedValue.includes('@prosegur.') && !normalizedValue.includes('@ext.prosegur.')
})

configure({
  validateOnInput: false,
  validateOnChange: true,
  validateOnBlur: true,
  validateOnModelUpdate: false,
})
